import { DEFAULT_BACKGROUND_COLOR } from 'src/app/config'
import { ImageService } from './../../services/image/image.service'
import { Keyboard } from '@ionic-native/keyboard/ngx'
import { IUser } from '../../services/user/user.service'
import { ActivatedRoute } from '@angular/router'
import { NavController, ActionSheetController } from '@ionic/angular'
import { AlertService } from '../../services/alert/alert.service'
import { GroupService, IGroup, IGroupUser } from 'src/app/services/group/group.service'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { UserService } from 'src/app/services/user/user.service'
import { InvitationService, IInvitee } from 'src/app/services/invitation/invitation.service'

@Component({
  selector: 'app-group-details',
  templateUrl: './group-details.page.html',
  styleUrls: ['./group-details.page.scss'],
})
export class GroupDetailsPage implements OnInit, OnDestroy {

  user: IUser = null
  userSubscription: any

  defaultGroup: IGroup = null
  group: IGroup = null

  groupsList: IGroup[] = []
  groupsListSubscription: any

  /* verified: IGroupUser[] = []
  notVerified: IGroupUser[] = [] */

  currentUser: IGroupUser = null

  editMode = false

  backgroundImageStyle: string
  backgroundImagePathSubscription: any

  constructor(
    private userService: UserService,
    private groupService: GroupService,
    private invitationService: InvitationService,
    private alert: AlertService,
    private navCtrl: NavController,
    private route: ActivatedRoute,
    public keyboard: Keyboard,
    private imgService: ImageService,
    private actionSheetCtrl: ActionSheetController,
  ) {
    this.userSubscription = this.userService.currentUser.subscribe(value => this.user = value)
    this.backgroundImagePathSubscription = this.imgService.appBackground.subscribe(value => {
      const url = this.imgService.urlPathForImage(value)
      if (url && url !== '')
        this.backgroundImageStyle = `url(${url}) no-repeat center/cover fixed`
      else
        this.backgroundImageStyle = DEFAULT_BACKGROUND_COLOR
    })
  }

  ngOnInit() {
    this.groupsListSubscription = this.groupService.groupList.subscribe(value => this.groupsList = value)

    this.init()
      .catch((err) => {
        this.alert.errorHandler(err, true)
        this.goBack()
      })
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe()
    this.backgroundImagePathSubscription.unsubscribe()
    this.groupsListSubscription.unsubscribe()
  }

  init() {
    const groupId = this.route.snapshot.paramMap.get('groupId')
    if (!groupId)
      return Promise.reject()
    else
      return this.groupService.getDetails(this.user.token, +groupId)
        .then((group: IGroup) => {
          this.defaultGroup = group
          this.resetData(group)
        })
  }

  toggleEditMode(mode: boolean) {
    this.editMode = mode
    if (!mode)
      this.resetData(this.defaultGroup)
  }

  resetData(group: IGroup) {
    this.editMode = false

    this.group = group

    /* this.verified = group.users.filter(u => u.verified)
    this.notVerified = group.users.filter(u => !u.verified) */

    this.currentUser = group.users.find(u => u.userId === this.user.id)
  }

  saveChanges() {
    this.groupService.saveDetails(
      this.user.token,
      this.group.id,
      this.group.name
    )
      .then(() => this.init())
      .catch((err) => this.alert.errorHandler(err, true))
  }

  trackByFn(index, item) {
    return item.userId
  }

  trackByFn2(index, item) {
    if (item.name)
      return item.name
    else
      return item.email
  }

  deleteGroup() {
    this.alert.confirmPrompt('Bist Du sicher, dass Du diese Gruppe entgültig löschen möchtest?', 'Gruppe löschen')
      .then(result => {
        if (result)
          this.groupService.deleteGroup(this.user.token, this.group.id)
            .then(() => this.goBack())
            .catch((err) => this.alert.errorHandler(err, true))
      })
  }


  async showAddUserActionSheet() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Benutzer Einladen',
      buttons: [
        {
          text: 'Per E-Mail einladen',
          icon: 'at',
          handler: () => {
            this.addUser('email')
          }
        }, {
          text: 'Aus Kontakten auswählen',
          icon: 'contacts',
          handler: () => {
            this.addUser('contacts')
          }
        }, {
          text: 'Abbrechen',
          icon: 'close',
          role: 'cancel'
        }
      ]
    })
    await actionSheet.present()
  }

  addUser(type: 'email' | 'contacts') {
    if (type === 'email')
      this.alert.inputPrompt([{ name: 'email', type: 'email', placeholder: 'E-Mail-Adresse' }], 'In die Gruppe einladen')
        .then(result => {
          if (typeof result !== 'undefined') {
            const email = result['email']
            this.invitationService.invite(this.user.token, this.group.id, null, email)
              .then(() => {
                this.init()
                this.alert.toast(`<strong>${email}</strong> wurde Eingeladen`)
              })
              .catch((err) => this.alert.errorHandler(err, true))
          }
        })
    else if (type === 'contacts') {
      let knownUsers: IGroupUser[] = []

      for (const group of this.groupsList)
        knownUsers = knownUsers.concat(group.users)

      knownUsers = knownUsers.filter(user => knownUsers.map(k => k.userId).indexOf(user.userId) !== -1)

      let contacts = []

      // { label: string, value: number }[]

      for (const user of knownUsers)
        if (contacts.map(c => c.userId).indexOf(user.userId) === -1)
          contacts.push(user)

      // console.log(knownUsers)
      // console.log(contacts.map(c => ({ label: c.name, value: c.userId })))

      contacts = contacts
        .map(c => ({ label: c.name, value: c.userId }))
        .filter(c =>
         /* c.value !== this.user.id &&  */this.group.users.map(u => u.userId).indexOf(c.value) === -1
        )

      this.checkboxPrompt(contacts, 'Einladen')
        .catch((err) => this.alert.errorHandler(err, true))
    }
  }

  checkboxPrompt(userList: { label: string, value: number }[], title: string) {
    return this.alert.checkboxPrompt(userList, title)
      .then(result => {
        if (result) {
          const tasks = []
          let itemsProcessed = 0

          Object.entries(result).forEach(([key, value], index, array) => {
            if (value)
              tasks.push(
                () => this.invitationService.invite(this.user.token, this.group.id, null, null, +key)
              )

            itemsProcessed++
            if (itemsProcessed === array.length) {
              const promises = tasks.map(task => task())

              return Promise.all(promises)
                .then(() => {
                  return this.init()
                })
            }
          })
        }
      })
  }

  /* this.userService.list(this.user.token)
    .then((list: IUser[]) => {
      const userList = list.filter(l => this.group.users
        .findIndex(u => u.userId === l.id) === -1)
        .map(u => ({ label: u.name, value: u.id }))

      return this.checkboxPrompt(userList, 'Personen hinzufügen')
    })
    .catch((err) => this.alert.errorHandler(err)) */


  deleteUser(user: IGroupUser) {
    if (user.userId === this.currentUser.userId)
      this.alert.confirmPrompt(`Bist Du sicher, dass Du aus dieser Gruppe austreten möchtest?`,
        'Gruppe verlassen')
        .then(result => {
          if (result)
            if (this.currentUser.owner) {
              const usersList =
                this.group.users
                  .filter(u => u.userId !== this.currentUser.userId)
                  .map(u => ({ label: u.name, value: u.userId }))

              if (usersList.length === 0)
                this.groupService.userDelete(this.user.token, this.group.id, this.currentUser.userId, true)
                  .then(() => this.goBack())
                  .catch((err) => this.alert.errorHandler(err))
              else
                this.alert.checkboxPrompt(
                  this.group.users.filter(u => u.userId !== this.currentUser.userId).map(u => ({ label: u.name, value: u.userId })),
                  'Nachfolger wählen',
                  true
                )
                  .then(selection => {
                    if (selection && Object.keys(selection).length !== 0)
                      this.groupService.userDelete(this.user.token, this.group.id, Object.keys(selection)[0], true)
                        .then(() => this.goBack())
                        .catch((err) => this.alert.errorHandler(err))
                  })
            } else
              this.groupService.userDelete(this.user.token, this.group.id, this.currentUser.userId, true)
                .then(() => this.goBack())
                .catch((err) => this.alert.errorHandler(err))

          /* this.groupService.userDelete(this.user.token, this.group.id, user.userId)
            .then(() => this.init())
            .catch((err) => this.alert.errorHandler(err)) */
        })
    else
      this.alert.confirmPrompt(`Bist Du sicher, dass Du <strong>${user.name}</strong> aus dieser Gruppe entfernen möchtest?`,
        'Mitglied entfernen')
        .then(result => {
          if (result)
            this.groupService.userDelete(this.user.token, this.group.id, user.userId)
              .then(() => this.init())
              .catch((err) => this.alert.errorHandler(err))
        })
  }

  deleteInvitation(invitation: IInvitee) {
    this.alert.confirmPrompt(`Bist Du sicher, dass Du diese Einladung zurückziehen möchtest?`,
      'Einladung zurückziehen')
      .then(result => {
        if (result)
          this.invitationService.deleteInvitation(this.user.token, invitation.invitationId)
            .then(() => this.init())
            .catch((err) => this.alert.errorHandler(err))
      })
  }


  /*  requestVerify() {
    this.groupService.userRequestVerify(this.user.token, this.group.id)
      .then(() => this.init())
      .catch((err) => this.alert.errorHandler(err))
  }

  confirmVerify(user: IGroupUser) {
    this.groupService.userConfirmVerify(this.user.token, this.group.id, user.userId)
      .then(() => this.init())
      .catch((err) => this.alert.errorHandler(err))
  }

  checkboxPrompt(userList: { label: string, value: number }[], title: string) {
    return this.alert.checkboxPrompt(userList, title)
      .then(result => {
        if (result) {
          const tasks = []
          let itemsProcessed = 0

          Object.entries(result).forEach(([key, value], index, array) => {
            if (value)
              tasks.push(
                () => this.groupService.userAdd(this.user.token, this.group.id, +key)
              )

            itemsProcessed++
            if (itemsProcessed === array.length) {
              const promises = tasks.map(task => task())

              return Promise.all(promises)
                .then(() => {
                  return this.init()
                })
            }
          })
        }
      })
  } */

  goBack() {
    return this.navCtrl.pop()
  }
}
